// extracted by mini-css-extract-plugin
export default {"balanceBlock":"Balance_balanceBlock--ZAc","balance":"Balance_balance--uv0","balanceText":"Balance_balanceText--MRd"};